//consolog("init js");
var _documentReady = false;
var _breakpointSmall = 0;
var _breakpointMedium = 768;
var _breakpointLarge = 992;
var _breakpointXLarge = 1200;
var _blazy = null;
var _ibsLogginCalls = 0;
var _foodtruckAnnualTotal = 0;
var _itwTunnelviewInterval = null;

var slickPrevArrowCode = "<button type='button' class='slick-prev' aria-label='navigate to previous slider page'></button>";
var slickNextArrowCode = "<button type='button' class='slick-next' aria-label='navigate to next slider page'></button>";

//Pfeil-Variante v2: helles Quadrat hinter dem Pfeil beim Hover (siehe _slider.scss)
var slickPrevArrowCodeV2 = "<button type='button' class='slick-prev slick-arrow--v2' aria-label='navigate to previous slider page'></button>";
var slickNextArrowCodeV2 = "<button type='button' class='slick-next slick-arrow--v2' aria-label='navigate to next slider page'></button>";

$(document).ready(function () {

	_documentReady = true;

	//handle greek text on safari
	if($("html").attr("lang") == "el-GR"){
		if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
			replaceGreekAccented();
		}
	}

	//console.log("Pantanenius => document ready");

	initHeaderBar();
	initNavigation();
	initSearch();
	initForms();
	initNotifications();
	initQuickfinder();
	initFooterBlocks();
	initProductBenifits();
	initContactTeaser();
	initImageGallery();
	initReviewSlider();
	initContentNavigation();
	initContentNavigationTabs();
	initArticleFilter();
	initCharterPackages();
	initPopup();
	initServiceTeaser();
	initCountrySelection();
	initQuickNav();
	initBoatsearchSlick();
	initQuoteForm();
	initUSQuoteForm();
	initRecommendationForm();
	initCookieCheck();
	initMultipleChoice();
	initPortCalculator();
	initImageTextColumns();
	initStorySlider();
	initProgressStage();
	initProductcompare();
	initTooltips();
	initContestForm();
	initPremiumExample();
	initFocusSlider();
	initArticleOverview();
	initAnchorNav();
	initDownloads();
	initDamageserviceTabs();
	initNewStage();
	initSolutions();

	initAviationForm();
	
	initCustomSelectboxes();
	loadTomSelectJs();


	setTimeout(function(){
		initFoodtruckCalculator();
		initRacingYachtInsuranceForm();
		//initAviationForm();	//no file upload in form - 2023-09-04
		
		initAccordions();
	}, 500);
	
	
	setSvgsInline();
	
	$(window).resize(handleResize);
	handleResize();
	
	setTimeout(handleResize, 1000);
	setTimeout(handleResize, 2500);
	setTimeout(handleResize, 5000);
	
	$('.col-eq-height').matchHeight({
		byRow: true,
		property: 'min-height',
	});
	$('.col-eq-height-all').matchHeight(true);
	$('.col-eq-min-height').matchHeight({ property: 'min-height' });
	

	//deactivate scroll animation in accordion elements
	$(".accordionBody").find(".scroll-animate").removeClass("scroll-animate");
		
	
	if($(window).width() >= _breakpointMedium){
		//deactivate scroll animation in first element
		$(".scroll-animate").first().removeClass("scroll-animate");

		initScrollAnimations();
	}
	else{
		//deactivate all scroll animations
		$(".scroll-animate").removeClass("scroll-animate");
	}
		
		
	//blazy image loading
	_blazy = new Blazy({
		loadInvisible: false,
		offset: 500,
		breakpoints: [
			{ width: _breakpointMedium, src: 'data-src-small' },
			{ width: _breakpointLarge, src: 'data-src-medium' }
		],
		success: function (ele) {
			//update same col height calculation
			$.fn.matchHeight._update();
			
			//console.log("blazy loaded! ele:" + ele.id);
		}, 
		error: function(ele, msg){
			//console.log("blazy error! ele:" + ele.id + " msg:" + msg); 
        }
	});
	
	//special button paddign for apple
	if (getApple()) {
		
		$(".apple").removeClass("apple");
		
		$(".primaryButton").addClass("apple");
		$(".primaryButton2").addClass("apple");
		$(".secondaryButton").addClass("apple");
		$(".iconButton").addClass("apple");
		$(".headerBarMenuLink").addClass("apple");
		$(".headerBarMenuLabel").addClass("apple");
		$(".footerAdditionalLinksHead").addClass("apple");
	}
	
	//start IBS logging
	setTimeout(startIbsLogging, 1000);
	
	//set username
	/*
	setTimeout(setLoginUsername, 1000);
	setTimeout(setLoginUsername, 2500);
	setTimeout(setLoginUsername, 5000);
	*/

	//logout button handling
	initIbsLogoutButton();
	
	//if ITW module is active on page
	if($(".itwWidgetContainer").length > 0){
		
		setInterval(function(){
			//update description every 5 seconds 
			updateDescription();
			
			//try to init tooltips every 5 seconds 
			initTooltips();
			
			//init progress view (Angebot2, Charter2)
			initProgressView();
			
			//init formfield2
			initFormField2();
			
			//init formField2 placeholders
			updateFormField2Placeholders();
			
			//update selectboxes
			updateItwSelectboxes();
			
			//init crewlist
			//initCrewlist();

			//show or hide password
			initPasswordHandling();
		}, 5000);

		setTimeout(checkIbsModuleLoading, 5000);
    }
});

/*
* SCROLL ANIMATIONS
*/

function initScrollAnimations(){
    let els = document.querySelectorAll(".scroll-animate");
	els = Array.from(els);
    els.forEach(el => {
		let th = 0.01;
		
		if(el.offsetHeight > window.innerHeight){
			let a = el.offsetHeight / window.innerHeight;
			let b = (a / window.innerHeight) / 2;
			if(b > 0 && b < th){
				th = b;
			}
		}

		//console.log("th: " + th);

        addScrollAnimationObserver(el, {
			threshold: th
		});
    });

}

function addScrollAnimationObserver(el, options){
	
	//console.log("addScrollAnimationObserver()");

    if(!('IntersectionObserver' in window)){
        if(options.cb){
            options.cb(el)
        }else{
            entry.target.classList.add('scroll-animate--active')
        }
        return
    }
    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                if(options.cb){
                    options.cb(el)
                }else{
                    entry.target.classList.add('scroll-animate--active')
                }
                observer.unobserve(entry.target)
            }
        })
    }, options)
    observer.observe(el)
}

/*
* SELECTBOX JS
*/

function loadSelectboxJs(){
	
	if ($('.chosen-style').length > 0 || $('.select-style').length > 0) {
		//console.log("load selectbox Js...");
		
		$.ajax({
			url: "https://cdnjs.cloudflare.com/ajax/libs/jquery-nice-select/1.1.0/js/jquery.nice-select.min.js",
			async: true,
			dataType: "script",
			success: function(){
				//console.log("loaded 'jquery.nice-select.min.js'");
				
				// create css element in head
				var head = document.getElementsByTagName('HEAD')[0];
				var csslink = document.createElement('link');
				csslink.rel = 'stylesheet';
				csslink.type = 'text/css';
				csslink.href = 'https://cdnjs.cloudflare.com/ajax/libs/jquery-nice-select/1.1.0/css/nice-select.min.css';
				head.appendChild(csslink);
				
				$.ajax({
					url: "https://cdnjs.cloudflare.com/ajax/libs/chosen/1.6.2/chosen.jquery.min.js",
					async: true,
					dataType: "script",
					success: function(){
						//console.log("loaded 'chosen.jquery.min.js'");

						// create css element in head
						var head = document.getElementsByTagName('HEAD')[0];
						var csslink = document.createElement('link');
						csslink.rel = 'stylesheet';
						csslink.type = 'text/css';
						csslink.href = 'https://cdnjs.cloudflare.com/ajax/libs/chosen/1.6.2/chosen.min.css';
						head.appendChild(csslink);

						//init 
						initSelectboxes();
					}
				});
			}
		});	
	}
}


function CookiebotCallback_OnAccept() {

	//console.log("CookiebotCallback_OnAccept() ...");

	//init some modules after marketing cookie check 
	if (Cookiebot.consent.marketing){      

		if(_documentReady){
			initVideoteaser();
			initVideoModul();
		}
		else{
			handleDocumentReadyAfterCookiebotReady();
		}

	}
}

function handleDocumentReadyAfterCookiebotReady(){
	if(_documentReady) {  
		initVideoteaser();
		initVideoModul();
	}
	else{
		setTimeout(handleDocumentReadyAfterCookiebotReady, 1000);
	}
}

function checkIbsModuleLoading(){
	if ($(".loading_ibsmodule").length > 0){
		$(".loading_ibsmodule").show();
	}
}

function consolog(message) {
	//console.log(message);
}

function initIbsLogoutButton(){
		// IBS logout
		$(".ibs_logout").unbind().click(function (e) {
			e.preventDefault();
	
			var err = false;
			if (typeof IBS !== "undefined") {
				if (typeof IBS.services !== "undefined") {
					IBS.services.logout();
				}
				else {
					err = true;
				}
			}
			else {
				err = true;
			}
	
			if (err) {
				console.log("IBS LOGOUT ERROR => IBS is not defined");
			}
			else{
				//fallback url
				var url = $(this).attr("data-url");
				if(url != ""){
					//$(".headerBarLoginNavigation__loader").show();
					setTimeout(function () {
						window.location.href = url;
					}, 1000);
				}
			}
	
		});
}

function startIbsLogging() {

	//console.log("startIbsLogging() ["+_ibsLogginCalls+", " + typeof IBS + ", '" + window.location.href + "']");

	_ibsLogginCalls++;

	if (typeof IBS !== "undefined") {

		if (typeof IBS.services !== "undefined") {
			if (typeof IBS.services.saveLandingpage !== "undefined") {
				IBS.services.saveLandingpage(window.location.href);
			}
			else {
				if (_ibsLogginCalls < 10) {
					setTimeout(startIbsLogging, 1000);
				}
			}
		}
		else {
			if (_ibsLogginCalls < 10) {
				setTimeout(startIbsLogging, 1000);
			}
		}

		//setLoginUsername();
	}
	else {
		if (_ibsLogginCalls < 10) {
			setTimeout(startIbsLogging, 1000);
		}
	}
}
function setLoginUsername(){
	
	//console.log("setLoginUsername()");
	
	//get username
	if (typeof IBS !== "undefined") {
		//console.log("setLoginUsername() ident:" + IBS.modulconfig.ident);
		if (IBS.modulconfig && $("#headerBarMenuLoginLink").length > 0) {
			var username = IBS.modulconfig.name;
			var $un = $("#headerBarMenuLoginLink").find(".username");
			if (username && $un){
				if ($un.length > 0) {
					if (username.length > 20) {
						username = username.substring(0, 20) + "...";
					}
					if (username != "") {
						$un.html(username);
					}
				}
			}
		}
	}
}

/*
function changeLoginButtonLabel(loggedIn){
	console.log("changeLoginButtonLabel("+loggedIn+")");
	
	const loginLink = document.getElementById("headerBarMenuLoginLink");
    if(loginLink){
        
        const labelLogin = loginLink.getAttribute("data-label-login")||'';
        const labelProfile = loginLink.getAttribute("data-label-myp")||'';
        const navLoginLabel = loginLink.getElementsByClassName("headerBarMenuLink")[0];
        if (navLoginLabel){
            if(loggedIn){
                navLoginLabel.innerHTML = labelProfile;

				//disable login button
				$("#headerBarMenuLoginLink").removeClass("headerBarMenuElement--flyout");
				$("#headerBarMenuLoginLink").addClass("headerBarMenuElement--disabled");
				$("#headerBarMenuLoginLink").attr("tabindex", "-1");
            }
            else{
                navLoginLabel.innerHTML = labelLogin;
            }
        }
    }
}
*/

function isMobile() {
	var isMobile = false; //initiate as false
	// device detection
	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
		isMobile = true;
	}
	return isMobile;
}

function handleResize() {
	updateHeaderBar();
	updateFooterBlocks();
	//updateImageGallery();
	updateQuickfinder();
	updateArticleTeaser();
	updateContactTeaser();
	updateContactList();
	updateProductBenifits();
	updateContentNavigationTabs();
	updateCountrySelection();
	updateQuickNav();
	updateFormFieldSize();
	updateDescription();
	updateProductFinderIcons();
	updateReviews();
	updateStorySlider();
	updateProgressStage();
	updateProductcompare();
	updateArticleOverview();
	updatePremiumExample();
	setTimeout(updatePremiumExample, 1000);
	handleCrewlistResize();
	updateGlobalHeader();
	updateCustomSelectboxes();
	
	//updateServiceTeaser();
	//updateTooltips();
}

function initNotifications() {

	if ($(".notificationBar").length > 0) {
		$(".notificationBar").each(function () {
			$nf = $(this);

			$nf.find(".notificationBarCloseButton").click(function () {
				$nf.find(".notificationBarHeader").fadeOut(250);
				setTimeout(function () {
					$nf.find(".notificationBarBody").fadeOut(250);
				}, 200);
			});
		});
	}
}

function getApple() {
	var userAgent = window.navigator.userAgent;
	var platform = window.navigator.platform;
	var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	var os = null;
	var apple = false;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'Mac OS';
		apple = true;
	}
	else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
		apple = true;
	}
	else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	}
	else if (/Android/.test(userAgent)) {
		os = 'Android';
	}
	else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	return apple;
}

/*
function showLoginResultInFlyout() {
	console.log("showLoginResultInFlyout()");
	
	//load login markup in flyout
	var url = $("#headerBarLoginContentRow").attr("data-success-url");
	$("#headerBarLoginContentRow").load(url, function() {
		//console.log("showLoginResultInFlyout() loaded!");
		
		initIbsLogoutButton();
		
		//show label in login button
		var labelMyP = $("#headerBarMenuLoginLink").attr("data-label-myp");
		var $un = $("#headerBarMenuLoginLink").find(".username");
		if($un.length > 0){
			$un.html(labelMyP);
		}
	
		//show username in login button
		setLoginUsername();
	});	
}
*/

function trackEvent(eventTitle, value, extraFields) {
	window.dataLayer = window.dataLayer || [];
	var additionalData = extraFields || {};
	var data = { 'event': eventTitle, 'conversionValue': value };
	data = Object.assign(data, additionalData);
	//console.log("trackEvent() data:" + JSON.stringify(data));
	window.dataLayer.push(data);
}

//svg handling
function setSvgsInline() {
	$('img[src$=".svg"]').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get(imgURL, function (data) {
			var $svg = $(data).find('svg');
			if (typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			if (typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass + ' replaced-svg');
			}
			$svg = $svg.removeAttr('xmlns:a');
			$img.replaceWith($svg);
		}, 'xml');
	});
}

function handleQuoteFormStep(step) {
	//console.log("handleQuoteFormStep() step:" + step);

	if(step >= 2){
		if(!$(".main").hasClass("darkBackground")){
			$(".main").addClass("darkBackground")
		}
		if(!$(".itwWidgetContainer").hasClass("darkBackground")){
			$(".itwWidgetContainer").addClass("darkBackground")
		}
	}
}

function ibsNavigateCallback(pageid) {
	console.log("ibsNavigateCallback() pageid:" + pageid);
}

function enterTunnelView() {
	//console.log("enterTunnelView()");
	if(!$("body").hasClass("tunnelView")){
		$("body").addClass("tunnelView");

		// setTimeout(equalizeItwColHeight, 1000);

		updateFormField2Placeholders();
		_itwTunnelviewInterval = setTimeout(updateFormField2Placeholders, 1000);
	};
}
function leaveTunnelView() {
	//console.log("leaveTunnelView()");
	$("body").removeClass("tunnelView");
	
	if(_itwTunnelviewInterval){
		clearInterval(_itwTunnelviewInterval);
		_itwTunnelviewInterval = null;
	}
}

function equalizeItwColHeight(){
	//equalize col height
	var $itwCols = $(".itwWidgetContainer").find(".col-eq-height").not(".eq-initialized");
	if($itwCols.length > 0){
		$itwCols.addClass("eq-initialized");
		$itwCols.matchHeight(true);
	}
}

function numberWithDots(n) {
	return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function enterContentNavigationTunnelView(){
	$(".contentNavigation").addClass("tunnelView");
}

function leaveContentNavigationTunnelView(){
	$(".contentNavigation").removeClass("tunnelView");
}

function replaceGreekAccented(){
	//console.log("Pantanenius => replace greek accented");
	
	if( typeof getComputedStyle == "undefined"){
		getComputedStyle = function(e) {
			return e.currentStyle;
		};
	}
	
	var elements = document.getElementsByTagName('*');
	for(var i=0; i<elements.length; i++) {
		if( getComputedStyle(elements[i]).textTransform == "uppercase") {
			elements[i].innerHTML = greekReplaceAccented(elements[i].innerHTML);
		}
	}
}
function greekReplaceAccented(str) {
    var charList = {'Ά':'Α','ά':'α','Έ':'Ε','έ':'ε','Ή':'Η','ή':'η','Ί':'Ι','ί':'ι','ΐ':'ϊ','Ό':'Ο','ό':'ο','Ύ':'Υ','ύ':'υ','ΰ':'ϋ','Ώ':'Ω','ώ':'ω','ς':'Σ'};
    return str.replace(/./g, function(c) {return c in charList? charList[c] : c}) ;
}

var _dragPosX = 0;
var _dragMinPosX = 0;
var _dragElement = null;

function dragMouseDown(e) {
    //e.preventDefault();
    
    _dragPosX = e.clientX;
    _dragElement = e.currentTarget;

    var parentWidth = _dragElement.parentElement.offsetWidth;
    var navWidth = _dragElement.scrollWidth;
    //console.log("parentWidth:" + parentWidth);
    //console.log("navWidth:" + navWidth);
    
    if(parentWidth < navWidth){
        //enable scrolling
        _dragMinPosX = parentWidth - navWidth - 10;
        //console.log("_dragMinPosX:" + _dragMinPosX);

        //document.onmouseup = closeDragElement;
        //document.onmousemove = elementDrag;
        if(e.type == 'mousedown'){
            document.addEventListener("mouseup", closeDragElement, {passive:false});
            document.addEventListener("mousemove", elementDrag, {passive:false});
        }
        else{
            document.addEventListener("touchend", closeDragElement, {passive:false});
            document.addEventListener("touchmove", elementDrag, {passive:false});
        }
    }
    else{
        //no scrolling
        return;
    }

}

function elementDrag(e) {
    e.preventDefault();

    var x = 0;
    if(e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'){
        var touch = e.touches[0] || e.changedTouches[0];
        x = touch.pageX;
    } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave') {
        x = e.clientX;
    }
    
	//console.log("elementDrag() x:" + x);
	//console.log("elementDrag() _dragPosX:" + _dragPosX);
	
    var p = _dragPosX - x;
    _dragPosX = x;
    
    var newX = _dragElement.offsetLeft - p;
    if(newX > 0){
		newX = 0;
	}
	
	if(newX > _dragMinPosX){
		_dragElement.style.marginLeft = newX + "px";
	}

	//console.log("elementDrag() newX:" + newX);

    if(!_dragElement.classList.contains("dragging")){
        _dragElement.classList.add("dragging");
    }
}

function closeDragElement() {
    //document.onmouseup = null;
    //document.onmousemove = null;
    document.removeEventListener("mouseup", closeDragElement);
    document.removeEventListener("mousemove", elementDrag);
    document.removeEventListener("touchend", closeDragElement);
    document.removeEventListener("touchmove", elementDrag);

    _dragElement.classList.remove("dragging");
}

function handleKeyDownForClick(e){
	if(e.which && (e.which == 9 || e.which == 16)){
		return;
	}
	$(this).trigger("click");
}
